export default "__VITE_ASSET__9d8bb5cc__"